import React from "react";
import PropTypes from "prop-types";
import { AppraisalSubmissionList } from "./AppraisalSubmissionList";
import { useTranslation } from "react-i18next";
import { Pagination } from "antd";

const AppraisalSubmissionDisplayForm = ({
  isLoading,
  isFromAdmin = false,
  onAdd,
  onView,
  data,
  setCurrentYear,
  pagination,
  setPagination,
  resetPagination,
}) => {
  const { t } = useTranslation();
  const footerElement = (footerValue, totalPagination) => (
    <div style={{ textAlign: "right", marginRight: "10px" }}>
      <Pagination
        style={{ display: "inline-flex", paddingRight: 10 }}
        defaultCurrent={pagination.current}
        current={pagination.current}
        total={totalPagination}
        onChange={onChangePagination}
        showTotal={(total) =>
          t("general.total") + ` ${total} ` + t("general.records")
        }
        defaultPageSize={pagination.pageSize}
        pageSize={pagination.pageSize}
      />
    </div>
  );

  function onChangePagination(page, pageSize) {
    setPagination({
      current: page,
      minIndex: (page - 1) * pageSize,
      maxIndex: page * pageSize,
      pageSize: pageSize,
    });
  }

  return (
    <div>
      <AppraisalSubmissionList
        isLoading={isLoading}
        isFromAdmin={isFromAdmin}
        data={data}
        onAdd={onAdd}
        onItemViewed={onView}
        isShowStatus={true}
        isMultipleAction={false}
        footerElement={footerElement}
        setCurrentYear={setCurrentYear}
        pagination={pagination}
        setPagination={setPagination}
        resetPagination={resetPagination}
      />
    </div>
  );
};

AppraisalSubmissionDisplayForm.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  isFromAdmin: PropTypes.bool,
  data: PropTypes.array.isRequired,
  onAdd: PropTypes.func,
  onView: PropTypes.func.isRequired,
  setCurrentYear: PropTypes.func.isRequired,
  pagination: PropTypes.object,
  setPagination: PropTypes.func,
  resetPagination: PropTypes.func,
};

export default AppraisalSubmissionDisplayForm;
